import { API_GET_ALL_BOOKINGS, API_BOOKING_CHANGE_STATUS, API_BOOKING_PAYMENTS, API_GET_BOOKING_DETAILS_BY_UNIQUE_ID, API_GET_BOOKING_DETAILS_BY_ID, API_GET_BOOKINGS_BY_BUSINESS_ID } from './BookingConstant';
import { bookingStatus } from './BookingStatus';
import HttpService from "../Http/HttpService";
import Logger from "../Logger/Logger";
import BookingResultsPojo from "./BookingPojo/BookingResultsPojo";
import Validator from "../Validator/Validator";
import BookingPaymentResultsPojo from './BookingPojo/BookingPaymentResultsPojo';

export class BookingService{
    
    private httpService = new HttpService();
    private logger = new Logger();
    private validator = new Validator();

    async getAll(): Promise<BookingResultsPojo>{
        try{
            const httpResult =  await this.httpService.get(API_GET_ALL_BOOKINGS, {}); 
            return { isSuccess : httpResult.data.isSuccess, bookings : httpResult.data.response.booking }
        } catch (e){
            this.logger.error(e);
            throw e;
        }
    }    

    async getAllByBusinessId(businessId: number): Promise<BookingResultsPojo>{
        try{
            this.validator.validatePositiveInteger(businessId);
            const httpResult = await this.httpService.get(API_GET_BOOKINGS_BY_BUSINESS_ID, { businessId });
            return { isSuccess : httpResult.data.isSuccess, bookings : httpResult.data.response.booking }
        } catch (e){
            this.logger.error(e);
            throw e;
        }
    }

    async getByUniqueId(bookingUniqueId: string): Promise<any> {
        try {
            this.validator.isValidString("bookingUniqueId", bookingUniqueId);
            const httpResult = await this.httpService.get(`${API_GET_BOOKING_DETAILS_BY_UNIQUE_ID}/${bookingUniqueId}`, {});
            return httpResult.data?.response?.bookingDetails ?? null;
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async getByBookingId(bookingId: number): Promise<any> {
        try {
            this.validator.validatePositiveInteger(bookingId);
            const httpResult = await this.httpService.get(`${API_GET_BOOKING_DETAILS_BY_ID}/${bookingId}`, {});
            const bookings = httpResult.data?.response?.booking ?? [];
            return Array.isArray(bookings) && bookings.length > 0 ? bookings[0] : null;
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }

    async changeStatus(bookingId: number, status: bookingStatus): Promise<Boolean>
    {
        try
        {
            this.validator.validatePositiveInteger(bookingId);
            this.validator.validateIntegerIncludingZero(status);
            
            const httpResult = await this.httpService.put(API_BOOKING_CHANGE_STATUS, {bookingId : bookingId, status : status});
            return httpResult.data.isSuccess;
        } catch (e){
            this.logger.error(e);
            throw e;
        }
    }

    async getBookingPayments(): Promise<BookingPaymentResultsPojo>{
        try{
            const httpResult =  await this.httpService.get(API_BOOKING_PAYMENTS, {}); 
            return { isSuccess : httpResult.data.isSuccess, bookingPayments : httpResult.data.response.bookingPayments }
        } catch (e){
            this.logger.error(e);
            throw e;
        }
    } 
}